import { Box, Typography } from "@mui/material";

export function BenefitItem({ icon, title, description, features, sx }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 3,
        p: 3,
        borderRadius: 2,
        boxShadow: 2,
        transition: "all 0.3s ease",
        overflow: "hidden",
        maxHeight: 85, // Altura inicial compacta
        "&:hover": {
          boxShadow: 4,
          transform: "translateY(-2px)",
          maxHeight: 400, // Altura expandida
          "& .content-hidden": {
            opacity: 1,
            maxHeight: "1000px",
            "& > *": {
              transform: "translateY(0)",
            },
          },
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            mb: 1,
            color: "text.primary",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </Typography>

        <Box
          className="content-hidden"
          sx={{
            opacity: 0,
            maxHeight: 0,
            overflow: "hidden",
            transition: "all 0.3s ease",
            "& > *": {
              transform: "translateY(20px)",
              transition: "transform 0.3s ease",
            },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              lineHeight: 1.6,
              mb: 1.5,
            }}
          >
            {description}
          </Typography>

          <Box
            component="ul"
            sx={{
              pl: 2.5,
              "& li": {
                mb: 1,
                color: "text.secondary",
              },
            }}
          >
            {features.map((feature, index) => (
              <Box component="li" key={index}>
                <Typography variant="body1">{feature}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
